const BACK_LABELS = new Set(['back', 'previous']);

/**
 * Resolve one participant-facing button to a single navigation intent.
 *
 * Older button templates could leave `action: "jump"` behind when restoring
 * a visible Back button.  The API applies the same rule: when an element is
 * both typed and visibly labelled as Back, it must undo the last real survey
 * transition.  Deliberately repurposed buttons such as a back-styled
 * "Continue" jump retain their explicit custom action.
 */
export const resolveSurveyButtonAction = (element = {}) => {
  const buttonType = String(element.buttonType || '').trim().toLowerCase();
  // ScreenRenderer paints `content`; `label` is legacy metadata and can be
  // stale independently, so it is only a fallback for visibility checks.
  const visibleText = String(element.content || element.label || '').trim().toLowerCase();

  if (buttonType === 'back' && BACK_LABELS.has(visibleText)) return 'back';
  if (element.action) return String(element.action).trim().toLowerCase();
  return buttonType || 'next';
};

/** Keep builder fields internally consistent when an author changes behavior. */
export const applySurveyButtonAction = (element, action) => {
  const nextAction = String(action || 'next').trim().toLowerCase();
  const buttonType = ['back', 'next', 'submit'].includes(nextAction)
    ? nextAction
    : 'custom';

  return {
    ...element,
    action: nextAction,
    buttonType,
    targetScreen: nextAction === 'jump' ? (element.targetScreen || '') : null,
  };
};

export default resolveSurveyButtonAction;
